import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountLockingInfo } from '../../../../shared/types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountLockingSubscriptionVariables = Types.Exact<{
  scope: Types.AccountScopeInput;
}>;


export type AccountLockingSubscription = { __typename?: 'Subscription', account?: { __typename?: 'UpdateAccountPayload', account: { __typename?: 'Account', id: string, lockedAt?: string | null, lockReason?: Types.LockReason | null } } | null };


export const AccountLocking = /*#__PURE__*/ gql`
    subscription AccountLocking($scope: AccountScopeInput!) {
  account(scope: $scope) {
    ... on UpdateAccountPayload {
      account {
        ...AccountLockingInfo
      }
    }
  }
}
    ${AccountLockingInfo}` as unknown as DocumentNode<AccountLockingSubscription, AccountLockingSubscriptionVariables>;

          

          export const useAccountLockingSubscription = (options?:SubscriptionHookOptions<AccountLockingSubscription, AccountLockingSubscriptionVariables>) => useSubscription(AccountLocking, options);

          

          export type AccountLockingSubscriptionOptions = SubscriptionHookOptions<AccountLockingSubscription, AccountLockingSubscriptionVariables>;

          

          export type AccountLockingSubscriptionResult = ReturnType<typeof useAccountLockingSubscription>;

          
